<template>
  <div id="main-card">
    <div id="square-box">
      <div id="header">
        <div id="header-img">
          <img
            :src="logoUrl"
            id="makuang-logo"
            alt="logo"
          />
        </div>
        <div id="header-text">PRESCRIPTION</div>
      </div>
      <div id="header-2">
        <div class="patient dateOfPrint">
          Date of Print: <u>{{ printPayload.dateOfPrint }}</u>
        </div>
        <div class="patient visitBranch">
          Visit Branch : <u>{{ printPayload.visitBranch }}</u>
        </div>
      </div>
      <div id="content-inside-square-box">
        <div class="patient">
          <strong> (Name) </strong> <u>{{ printPayload.name }}</u>
          <strong> (NRIC/Passport) </strong>
          <u>{{ printPayload.nric }}</u>
          <strong> (D.O.B.) </strong>
          <u>{{ printPayload.dateOfBirth }}</u>
          has been prescribed the following herbal medication on
          {{ printPayload.dateOfPrescription }}:
        </div>
        <div class="blank-empty-space-2"></div>
        <vue-good-table
          :columns="columns"
          :rows="printPayload.items"
          id="prescription-table"
        />
        <div class="blank-empty-space-2"></div>
        <div id="weight">
          Total Weight: {{ printPayload.weightPerPacket | to2Decimal }} g per packet
        </div>
        <div class="blank-empty-space-2"></div>
        <div>
          * This prescription should be consumed under the advice of a licensed
          TCM physician. {{ this.orgName }} does not encourage the purchase of this herbal
          prescription from external sources other than our clinics.
        </div>
        <div>Remarks:</div>
        <div id="blank-square-box"></div>
        <div>
          Prescribed By: (Name of TCM physician)
          <u>{{ printPayload.nameOfPrescriber }}</u>
        </div>
      </div>
    </div>
    <b-button
      class="btn print-button"
      variant="primary"
      @click.prevent="printForm"
      >Print Prescription</b-button
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import printJS from 'print-js';
import money from '@/components/mixins/money';

export default {
  name: 'Prescription',
  async created() {
    // 1. Check if the printPayload is empty
    this.printPayload = this.$store.state.tcmConsultation
      .tcmPrescriptionPrintPayload;

    // 2. If the this.printPayload is empty, redirect them to the home page.
    if (!this.printPayload) {
      if (this.$route.query.consultation) {
        const consultationPrescription = await this.getTcmConsultationPrescriptionById(this.$route.query.consultation);
        this.printPayload = this.mapTCMConsultationForPrint(consultationPrescription)
      } else {
        this.$router.push('/patient/list');
      }
    }
  },
  mixins: [money],
  computed: {
    // ...mapGetters('tcmConsultation', ['printPayload']),
    ...mapGetters('config', {
      generalConfig: 'general',
      featureFlags: 'featureFlags',
    }),
    logoUrl() {
      let url = '';

      if (this.generalConfig && this.generalConfig.logoURL) {
        url = this.generalConfig.logoURL;
      }

      return url;
    },
    orgName() {
      if (this.generalConfig && this.generalConfig.clinicName) {
        return this.generalConfig.clinicName;
      }

      if (this.featureFlags && this.featureFlags.orgTcm) {
        return 'ORG TCM';
      }

      return 'Ma Kuang';
    },
  },
  data() {
    return {
      printPayload: {},
      columns: [
        {
          label: 'CODE',
          field: 'givenId',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          label: 'MEDICINE-CHI',
          field: 'chineseName',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          label: 'MEDICINE',
          field: 'name',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          label: 'QUANTITY',
          field: 'quantity',
          sortable: false,
          tdClass: 'text-center',
        },
        {
          label: 'NOTE',
          field: 'description',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
    };
  },
  methods: {
    ...mapActions('print', ['getTcmConsultationPrescriptionById']),
    printForm() {
      printJS('square-box', 'html');
    },
    mapTCMConsultationForPrint(consultationDetails) { // logic taken from src/components/TCMConsultation/Prescription/PSPreviewAll/Main.vue v1
      const currentPatient = consultationDetails.patient;
      const prescriptions = consultationDetails?.order && consultationDetails?.order.length > 0 ? consultationDetails?.order : []
      const prescription = prescriptions.length > 0 ? prescriptions[0] : {}
      let dateOfBirth;
      if (currentPatient.dateOfBirth) {
        const dateOfBirthstr = currentPatient.dateOfBirth.toString();
        dateOfBirth = `${dateOfBirthstr.slice(0, 4)}/${dateOfBirthstr.slice(5, 6)}/${dateOfBirthstr.slice(6)}`;
      } else {
        dateOfBirth = '';
      }

      // 2. Only pass the items that are relevant
      const items = prescription.items.map(element => ({
        quantity: `${(element.qty || 0).toString()} ${element.purchasingUnit || ''}`,
        givenId: element.givenId || '',
        name: element.name || '',
        chineseName: element.chineseName || '',
        description: element.description || '',
      }));

      const powderDosage = prescription.powderDosage || 0;
      const patentDosage = prescription.patentDosage || 0;
      const herbalDosage = prescription.herbalDosage || 0;
      const totalPackages = prescription.totalPackages || 1;

      // 3. Creating a payload to be printed
      return {
        name: currentPatient.name,
        nric: currentPatient.nric || '',
        dateOfBirth,
        dateOfPrint: new Date().toDateString('en-US'),
        visitBranch: consultationDetails.clinic.name,
        items,
        dateOfPrescription: new Date(consultationDetails.visitDate).toDateString('en-US'),
        nameOfPrescriber: JSON.parse(localStorage.getItem('user')).name,
        weightPerPacket: (Number(powderDosage) + Number(patentDosage) + Number(herbalDosage)) / Number(totalPackages),
      };
    }
  },
};
</script>

<style scoped>
/* Hide the print screen if the screen is too small */
@media screen and (min-width: 768px) {
  .blank-empty-space-2 {
    height: 0.5cm;
  }

  #blank-square-box {
    height: 10cm;
  }

  #content-inside-square-box {
    margin: 2%;
  }

  #header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1%;
    max-height: 20%;
  }

  #header-2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 2%;
    margin-right: 2%;
  }

  #header-text {
    width: 50%;
    justify-content: start;
    text-align: start;
  }

  #main-card {
    display: flex;
    font-size: x-large;
    flex-direction: column;
    margin: 0% 5%;
  }

  #makuang-logo {
    max-width: 30%;
    margin: 1%;
  }
  .patient {
    margin-bottom: 1%;
  }

  #prescription-table {
    margin-top: 2%;
    margin-bottom: 2%;
    width: fit-content;
  }

  .print-button {
    width: fit-content;
    margin-top: 2%;
    padding: 0.5%;
  }
  #square-box {
    border: 1px solid black;
  }

  #weight {
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media screen and (max-width: 767px) {
  #main-card {
    visibility: hidden;
  }
}
</style>
